export default {
  name: 'TextFieldMixin',

  props: {
    label: String,
    hint: String,
    placeholder: String,
    defaultValue: {
      type: [ String, Number ],
      default: ''
    },
    hideDetails: {
      type: [ String, Boolean ],
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    disabled: Boolean,
    readonly: {
      type: Boolean,
      default: false
    }
  }
}
